import { toast } from "core/Operations/toast";
import { messaging } from "./firebase";
import { getToken, onMessage } from "firebase/messaging";
import { fetchNotifications } from "core/redux/slice/notification";

export const requestPermission = async () => {
  const permission = await Notification.requestPermission();

  if (permission === "granted") {
    const token = await getToken(messaging, {
      vapidKey:
        "BFz0k_IGk_F-kX3HpYLZeE7JLWOAjmy8hYnt1a6REcfx2mE1t8fZVZd3hCuGascVN_NWZFVXcQTRHIC4wss9otY",
    });

    return token;

    // console.log("FCM TOKEN:", token);
  }
};

export const listenNotification = (dispatch, userData) => {
  onMessage(messaging, (payload) => {
    console.log("Message received:", payload);

    toast.warning(payload.notification.body);

    dispatch(fetchNotifications(userData));

    // alert(payload.notification.title);
  });
};
